// path: frontend/src/hooks/useAuth.js
/**
 * useAuth: контекст AuthProvider + UX-хелперы hasRole/hasAnyRole.
 *
 * hasRole/hasAnyRole — простой `roles.includes()` по СЫРЫМ ролям
 * пользователя (не effective). Для RBAC-проверок UI использовать
 * capabilities: ctx.capabilities.canCreateTask и т.п. Effective-роли
 * (замещения) видны только в capabilities — они приходят с бэка
 * через computeCapabilities(findByIdWithEffective).
 *
 * hasRole остаётся для сценариев «показать бейдж роли в карточке» —
 * это не RBAC-проверка, а отображение.
 */
import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  const roles = ctx.user?.roles || [];
  const hasRole = (role) => roles.includes(role);
  const hasAnyRole = (...rs) => rs.some((r) => roles.includes(r));

  return {
    user: ctx.user,
    capabilities: ctx.capabilities,
    isLoading: ctx.isLoading,
    login: ctx.login,
    logout: ctx.logout,
    forceChangePassword: ctx.forceChangePassword,
    passwordStatus: ctx.passwordStatus,
    roles,
    hasRole,
    hasAnyRole,
  };
};
